import React from "react";
import "../styles/ads.scss";
import useClientConfig from "../config/careers/clientConfig";

const AdsPlaceholder = ({ placement, clientConfig, styleClass } : { placement: string, clientConfig: any, styleClass?: string }) => {

    const { clientAssetsLink } = useClientConfig();

    const adConfig = clientConfig?.clientSiteSettings?.adsConfig?.adPlacements?.find(
        (ad : any) => ad.id === placement
    );
    if (!clientConfig?.clientSiteSettings?.adsConfig?.enabled || !adConfig?.enabled) {
        return null;
    }

    const image = adConfig.imgUrl ? (
        <img src={clientAssetsLink + adConfig.imgUrl} className="img-fluid" alt={`ad ${placement}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    ) : null;

    return (
        <div
            className={`ad-container ${styleClass}`}
            data-placement={placement}
            style={{
                width: adConfig.size.width,
                height: adConfig.size.height
            }}
        >
            <div id={`ad-${placement}`}>
                {adConfig.linkUrl ? (
                    <a href={adConfig.linkUrl} target="_blank" rel="noopener noreferrer">
                        {image}
                    </a>
                ) : image}
            </div>
        </div>
    );
};

export default AdsPlaceholder;